import { Link } from "react-router-dom";

import logo from "../../assets/logo-img.svg";

export default function SelectRoleNavigation({
  currentStep,
  title,
  text,
  handleIncrement,
  handleDecrement,
  validationButton,
}) {
  return (
    <>
      <div className="container">
        <div className="select-role-navigation-wrapper">
          <div className="row-essy items-center-essy">
            <div className="col-essy-md-4 col-essy-lg-4 col-essy-6">
              <div className="select-role-navigation__logo">
                <Link to="/">
                  <img src={logo} />
                </Link>
              </div>
            </div>
            <div className="col-essy-md-4 col-essy-lg-4 col-essy-step">
              <div className="step-rol-step-box">
                <p variant="span">Step {currentStep} of 3</p>
                <h3>{title}</h3>
                <p>{text}</p>
              </div>
            </div>
            <div className="col-essy-md-4 col-essy-lg-4 col-essy-6 col-essy-button">
              <div className="select-role__buttons-prev-next">
                {currentStep > 1 && (
                  <button
                    type="button"
                    onClick={handleDecrement}
                    className="btn-back"
                  >
                    Back
                  </button>
                )}
                {currentStep < 3 ? (
                  <button
                    type="button"
                    className={`${
                      !validationButton ? "" : "btn-disabled"
                    } btn-all-white`}
                    onClick={handleIncrement}
                    disabled={!validationButton ? false : true}
                  >
                    Next
                  </button>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
